<template>
  <div class="card-item" :data-id="card.id" :data-type="card.type" :class="{ 'card-horizontal': isHorizontal }"
    @click="handleClick">
    <img v-if="card && card.img" :src="card.img" :alt="card.name" class="card-image" :class="rotationClass"
      @load="onImageLoad" />
    <span v-else>{{ card.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    card: {
      type: Object,
      required: true
    },
    areaType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isImagePortrait: null,
    };
  },
  computed: {
    isHorizontal() {
      // エリアがステージで、カードにisRotatedプロパティが存在する場合
      if (['stage', 'energy'].includes(this.areaType) && Object.prototype.hasOwnProperty.call(this.card, 'isRotated'))
        // カード自身の回転状態を返す
        return this.card.isRotated;
      // それ以外のエリアは、これまで通りの判定
      return ['live', 'successfulLive', 'resolutionArea'].includes(this.areaType);
    },
    // 回転用のCSSクラスを動的に返す算出プロパティ
    rotationClass() {
      // 画像が読み込まれていなければ何もしない
      if (this.isImagePortrait === null) {
        return '';
      }

      const isContainerPortrait = !this.isHorizontal;

      // 縦長コンテナに横長画像の場合
      if (isContainerPortrait && !this.isImagePortrait) {
        return 'rotate-cw'; // 時計回り (Clockwise)
      }
      // 横長コンテナに縦長画像の場合
      else if (!isContainerPortrait && this.isImagePortrait) {
        return 'rotate-ccw'; // 反時計回り (Counter-Clockwise)
      }

      // 上記以外（縦長に縦長、横長に横長）の場合は回転不要
      return '';
    }
  },
  methods: {
    onImageLoad(event) {
      const img = event.target;
      this.isImagePortrait = img.naturalHeight > img.naturalWidth;
    },

    handleClick() {
      this.$emit('card-clicked', this.card);
    }
  }
}
</script>

<style scoped>
.card-item {
  width: 126px;
  height: 176px;
  border-radius: 6px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.9em;
  text-align: center;
}

.card-item:active {
  cursor: grabbing;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-horizontal {
  width: 176px;
  height: 126px;
}

/* 横長コンテナ(176x126) + 縦長画像 -> 反時計回り(-90deg) */
.card-image.rotate-ccw {
  height: 176px;
  width: auto;
  transform-origin: center;
  transform: rotate(-90deg);
}

/* 縦長コンテナ(126x176) + 横長画像 -> 時計回り(90deg) */
.card-image.rotate-cw {
  height: 126px;
  width: auto;
  transform-origin: center;
  transform: rotate(90deg);
}
</style>